<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = defineProps<{
  product: Schemas["Product"];
}>();
const { product } = toRefs(props);

const { unitPrice, price, tierPrices, isListPrice } = useProductPrice(product);
const { getFormattedPrice } = usePrice();

</script>

<template>
  <div class="price price--alt product__price">
    <div class="product-list-price" v-if="tierPrices.length <= 1">
      <SharedPrice v-if="unitPrice" :class="{'old-price': isListPrice}" :value="unitPrice"/>
      <SharedPrice v-if="isListPrice" :class="{'current-price': isListPrice}" :value="price?.listPrice?.price"/>
      <p />
    </div>
    <div v-else>
      <table class="table">
        <thead>
          <tr>
            <th>{{ $t("product.amount") }}</th>
            <th>{{ $t("product.price.label") }}</th>
          </tr>
        </thead>
        <tbody class="bg-white dark:bg-secondary-800">
          <tr v-for="(tierPrice, index) in tierPrices" :key="tierPrice.label">
            <td>
              <span v-if="index < tierPrices.length - 1">
                {{ $t("product.price.to") }}</span><span v-else> {{ $t("product.price.from") }}</span>
              {{ tierPrice.quantity }}
            </td>
            <td>{{ getFormattedPrice(tierPrice.unitPrice) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
